import React, { useEffect, useState } from "react";
import { Box, Typography, FormControl, Select, MenuItem, Tabs, Tab } from "@mui/material";
import { getData, postData } from "../../../../services/axiosInstance";
import { API_ENDPOINTS } from "../../../../services/endpoints";
import Loader from "../../../../common/spinner";
import PayInfo from "./payInfo";
import ProcessFlowView from "./processFlowView"; // Import the new component

function RunPayroll({ onNavigateToPayrollRecords }) {
    const [payPeriod, setPayPeriod] = useState("");
    const [monthOptions, setMonthOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [tabValue, setTabValue] = useState(0);

    const getShortMonth = (fullMonth) => {
        return new Date(`${fullMonth} 1, 2020`).toLocaleString("en-US", { month: "short" });
    };

    const formatMonth = (monthString) => {
        const [year, month] = monthString.split("-");
        const date = new Date(year, month - 1, 1);
        return date.toLocaleString("en-US", { month: "long", year: "numeric" });
    };

    useEffect(() => {
        const fetchMonths = async () => {
            setLoading(true);
            try {
                const response = await getData(API_ENDPOINTS.getPayrollMonthsDropdown);
                if (response?.statusCode === 200) {
                    const sorted = [...response.result.months].sort((a, b) => new Date(b) - new Date(a));
                    const formatted = sorted.map((m) => formatMonth(m));
                    setMonthOptions(formatted);
                    if (formatted.length > 0) setPayPeriod(formatted[0]);
                }
            } catch (error) {
                setMonthOptions([]);
                return null;
            } finally {
                setLoading(false);
            }
        };
        fetchMonths();
    }, []);

    const handlePayPeriodChange = async (value) => {
        setPayPeriod(value);
        const [fullMonth, year] = value.split(" ");
        const payload = { payPeriod: `${getShortMonth(fullMonth)} ${year}` };

        setLoading(true);
        try {
            await postData(API_ENDPOINTS.createBatchPayroll, payload);
        } catch (error) {
            return null;
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box sx={{ p: 1 }}>
            {loading && <Loader />}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                <Typography variant="h5" fontWeight="bold">Run Payroll</Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Typography variant="subtitle1" fontWeight="bold">Select Pay Period</Typography>
                    <FormControl sx={{ minWidth: 200 }} size="small">
                        <Select value={payPeriod} onChange={(e) => handlePayPeriodChange(e.target.value)}>
                            {monthOptions.map((m) => <MenuItem key={m} value={m}>{m}</MenuItem>)}
                        </Select>
                    </FormControl>
                </Box>
            </Box>

            <Tabs
                value={tabValue}
                onChange={(e, newVal) => setTabValue(newVal)}
                indicatorColor="primary"
                textColor="primary"
                sx={{ borderBottom: "1px solid #e0e0e0", mb: 2, '& .MuiTab-root': { textTransform: 'none' } }}
            >
                <Tab label="Payroll Information" />
                <Tab label="Process Flow" />
                <Tab label="Payroll Batch" />
            </Tabs>

            <Box sx={{ width: '100%' }}>
                {tabValue === 0 && <PayInfo payPeriod={payPeriod} />}
                {tabValue === 1 && <ProcessFlowView payPeriod={payPeriod} />}
            </Box>
        </Box>
    );
}

export default RunPayroll;